import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { MatDialog, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import {
  MatPaginator,
  MatPaginatorIntl,
  MatPaginatorModule,
  PageEvent,
} from "@angular/material/paginator";
import { MatSort, MatSortModule } from "@angular/material/sort";
import WarehouseAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/warehouse/warehouse.entity";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule, FormsModule, FormControl, Validators, FormGroup, FormBuilder } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatOptionModule } from "@angular/material/core";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavContainer } from "@angular/material/sidenav";
import { MatSlideToggle } from "@angular/material/slide-toggle";
import { MatTableModule, MatRowDef } from "@angular/material/table";
import { MatTooltipModule } from "@angular/material/tooltip";
import { ICreateWarehouse } from "./interfaces/create-warehouse.interface";
import { WarehouseService } from "./warehouse.service";
import { IUpdateWarehouse } from "./interfaces/update-warehouse.interface";
import CompanyAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/company/company.entity";
import PriceListAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/masters/price-list/price-list.entity";
import PlantsAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/plants/plants.entity";
import { CompanyService } from "../company/company.service.service";
import { PriceListService } from "../../master/price-list/price-list.service";
import { MatTabsModule } from "@angular/material/tabs";
import { NgLabelTemplateDirective, NgOptionTemplateDirective, NgSelectComponent, NgSelectModule } from "@ng-select/ng-select";
import { PlantsService } from "../plant/plants.service";
import { CustomMatPaginatorIntl } from "app/mock-api/common/customPaginatorIntl";
import { ReplaySubject, Subject, Subscription, take, takeUntil } from "rxjs";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { getCode } from 'app/utils/method';
import { MatRadioModule } from "@angular/material/radio";
import { ExportService } from "app/layout/export-overlay/export-overlay.service";
import { ExportDialogComponent } from 'app/layout/export-overlay/dialog/export-dialog.component';
import { ExportOptions } from "app/layout/export-overlay/tasks/core/export-task.interfaces";
import { WarehouseExport } from "./exports/warehouse.export";
import { WAREHOUSE_TITLE } from "./exports/warehouse.constants";
import { FilterComponent } from "app/common/components/filter/filter.component";
import { SearchService } from "app/layout/common/search-page/search-page.service";
import { StatusFiltersComponent } from "../../filters/status-filters/status-filters.component";
import { ConfigurationFiltersComponent } from "../../filters/configuration-filters/configuration-filters.component";
import { IFilters } from "../../filters/interfaces/filterInterface";
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";
import { FormSectionComponent } from "app/shared/components/form-ui/form-section/form-section.component";
import { ConfirmationService } from "app/shared/services/confirmation.service";
import { HandlerMessageService } from "app/common/services/handler-error/handler-message.service";

@Component({
  selector: "app-warehouse",
  standalone: true,
  templateUrl: "./warehouse.component.html",
  styleUrl: "./warehouse.component.scss",
  imports: [
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIcon,
    MatSlideToggle,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatRowDef,
    MatSidenavContainer,
    FormsModule,
    NgLabelTemplateDirective,
    NgOptionTemplateDirective,
    NgSelectComponent,
    NgSelectModule,
    MatTabsModule,
    NgxMatSelectSearchModule,
    MatRadioModule,
    FilterComponent,
    StatusFiltersComponent,
    ConfigurationFiltersComponent,
    HoverMenuDirective,
    FormSectionComponent
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
    WarehouseExport
  ],
})
export class WarehouseComponent implements AfterViewInit, OnDestroy {
  getCode = getCode;
  displayedColumns: string[] = ["name","plant","company", "status","readOnly","actions"];
  currentCreateWarehouse: ICreateWarehouse = this.initializeCreateWarehouse();
  currentUpdateWarehouse: WarehouseAttributes | undefined;

  dataSource: WarehouseAttributes[] = [];
  companyList: CompanyAttributes[] = [];
  selectedCompanyIds: string[] = [];
  plantList: PlantsAttributes[] = [];
  priceList: PriceListAttributes[] = [];
  discountList: PriceListAttributes[] = [];
  searchQuery: string = "";
  totalItems: number = 0;
  pageSize: number = 50;
  pageIndex: number = 1;
  dialogRefAdd: MatDialogRef<any>;
  dialogRefEdit:MatDialogRef<any>;

  selectedStatus: number[] = [];

  /** control for the selected plant for multi-selection */
  public plantMultiCtrl: FormControl<PlantsAttributes[]> = new FormControl<
    PlantsAttributes[]
  >([], Validators.required);

  /** control for the MatSelect filter keyword multi-selection */
  public plantMultiFilterCtrl: FormControl<string> = new FormControl<string>(
    ""
  );

  /** list of plant filtered by search keyword */
  public filteredPlants: ReplaySubject<PlantsAttributes[]> = new ReplaySubject<
    PlantsAttributes[]
  >(1);

  /** local copy of filtered plant to help set the toggle all checkbox state */
  protected filteredPlantCache: PlantsAttributes[] = [];


  /** flags to set the toggle all checkbox state */
  isIndeterminate = false;
  isChecked = false;
  
 /** control for the selected company for multi-selection */
    public companyMultiCtrl: FormControl<CompanyAttributes[]> = new FormControl<
    CompanyAttributes[]
  >([]);

  /** control for the MatSelect filter keyword multi-selection */
  public companyMultiFilterCtrl: FormControl<string> = new FormControl<string>(
    ""
  );

  /** list of company filtered by search keyword */
  public filteredCompany: ReplaySubject<CompanyAttributes[]> = new ReplaySubject<
    CompanyAttributes[]
  >(1);

  /** local copy of filtered company to help set the toggle all checkbox state */
  protected filteredCompanyCache: CompanyAttributes[] = [];

  /** flags to set the toggle all checkbox state */
  isIndeterminateComp = false;
  isCheckedComp = false;


  @ViewChild("editModal") editModal!: TemplateRef<any>;
  @ViewChild("addModal") addModal!: TemplateRef<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild("searchInput") searchInput!: ElementRef;
  protected _onDestroy = new Subject<void>();

  //BUSCADOR
  searchSubscription: Subscription;

  selectedStatuses: number[] = [];
  form: FormGroup;

  // Lazy loading
  loadFiltersData = false;
  private companiesLoaded = false;
  private plantsLoaded = false;
  private dataLoadedForModals = false;

  constructor(
    private readonly warehouseService: WarehouseService,
    private readonly companyService: CompanyService,
    private readonly plantsService: PlantsService,
    private readonly priceListService: PriceListService,
    private readonly searchService: SearchService,
    private readonly confirmationService: ConfirmationService,
    private dialog: MatDialog,
    private readonly handlerMessage: HandlerMessageService,
    private cdr: ChangeDetectorRef,
    public exportService: ExportService,
    private warehouseExport: WarehouseExport,
    private fb: FormBuilder,
  ) {
    this.form = this.fb.group({
      companyId: [],
      plantId: [],
    });
  }

  ngAfterViewInit(): void {
    this.onHandleSearch();
    this.setupPaginationAndSorting();
    this.findAllWithCount();
  }

  private ensureCompaniesLoaded(): void {
    if (!this.companiesLoaded) {
      this.fetchCompanies();
    }
  }

  private ensurePlantsLoaded(): void {
    if (!this.plantsLoaded) {
      this.fetchAllPlants();
    }
  }

  private ensureModalDataLoaded(): void {
    if (!this.dataLoadedForModals) {
      this.initializeComboBox();
      this.dataLoadedForModals = true;
    }
  }

  onFilterPanelOpened(): void {
    this.loadFiltersData = true;
    this.ensureCompaniesLoaded();
    this.ensurePlantsLoaded();
  }

  private initializeCreateWarehouse(): ICreateWarehouse {
    return {
      code: "",
      name: "",
      companyid: "",
      priceListId: "",
      discountListId: "",
      plantsId: [],
    };
  }

  applyAndCloseSidenav() {
    this.findAllWithCount();
  }

  toggleRole(status: number): void {
    this.selectedStatus = [];
    this.selectedStatus.push(status);
  }

  private setupPaginationAndSorting(): void {
    this.paginator.page.subscribe(() => this.findAllWithCount());
    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
      this.findAllWithCount();
    });
  }
  getSelectedCompanyCodes(selectedCompanyIds: string[]): number[] {
    return selectedCompanyIds.map(
      (id) => this.companyList.find((group) => group._id.toString() === id)?.id
    );
  }

  findAllWithCount(): void {
    // const pageIndex = this.paginator.pageIndex + 1;
    const sortField = this.getSortField();
    const sortDirection: "ASC" | "DESC" =
    this.sort.direction === "asc" ? "ASC" : "DESC";
    // const plantIds = this.plantMultiCtrl.value.map((material: PlantsAttributes) =>
    //   material.id)
 
    // const companyCodes = this.companyMultiCtrl.value.map((company: CompanyAttributes) =>
    //   company.id)
    let filter: IFilters = {
      companyId: this.form.get("companyId").value,
      plantId: this.form.get("plantId").value,
      status: this.selectedStatuses,
    }
    this.warehouseService
      .findAllWithCount({
        currentPage: this.pageIndex,
        limitPerPage: this.pageSize,
        search: this.searchQuery,
        sort: sortField,
        sortDirection: sortDirection,
      },
    filter
   )
      .subscribe((data) => {
        this.dataSource = data?.data?.[0]?.data ?? [];
        this.totalItems = data?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
        this.paginator.length = this.totalItems;
      });
  }

  private getSortField(): keyof WarehouseAttributes {
    const validSortFields: (keyof WarehouseAttributes)[] = ["name", "statusId"];
    return validSortFields.includes(
      this.sort.active as keyof WarehouseAttributes
    )
      ? (this.sort.active as keyof WarehouseAttributes)
      : "name";
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex + 1;
    this.findAllWithCount();
  }

  onSearchChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.searchQuery = input.value.trim();
    if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
      // this.paginator.pageIndex = 0;
      this.findAllWithCount();
    }
  }

  public onHandleSearch(){
    this.searchSubscription = this.searchService.searchTerm$
      .subscribe(term => {
        this.searchQuery = term;
        if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
          this.findAllWithCount();
        }
      });
  }

  trackByFn(index: number, item: WarehouseAttributes): string {
    return item._id.toString();
  }

  initializeComboBox(){
    this.fetchCompanies();
    this.fetchPriceList();
    this.fetchAllDiscountPrice();
    this.fetchAllPlants();
  }

  private fetchAllPlants(): void {
    this.plantsService.findToComboBox().subscribe({
      next: (res) => {
        this.plantList = res.data;
        this.plantsLoaded = true;
        this.filteredPlants.next(this.plantList);
        this.filteredPlants.pipe(take(1)).subscribe((prices) => {
          const selectedMaterials = prices.filter((price) =>
            this.currentUpdateWarehouse.plants.map(a=>a._id.toString())
              .includes(price._id.toString())
          );
          this.plantMultiCtrl.setValue(selectedMaterials);
        });

        // listen for search field value changes
        this.plantMultiFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filterRouteMulti();
            this.setToggleAllCheckboxState();
          });
      },
      error: (err) => {
        this.handlerMessage.error({
          message: err.error.message,
          alternativeMessage: "Error al obtener plantas."
        });
      },
    });
  }

  protected filterRouteMulti() {
    if (!this.plantList) {
      return;
    }
    // get the search keyword
    let search = this.plantMultiFilterCtrl.value;
    if (!search) {
      this.filteredPlantCache = this.plantList;
      this.filteredPlants.next(this.plantList);
      return;
    } else {
      search = search.toLowerCase();
    }
    // Filtrar los precios por nombre o código
    this.filteredPlantCache = this.plantList.filter((material) => {
      const nameMatches = material.name.toLowerCase().indexOf(search) > -1;
      const codeMatches =
        material?.externalKeys?.code.toLowerCase().indexOf(search) > -1;
      return nameMatches || codeMatches;
    });
    this.filteredPlants.next(this.filteredPlantCache);
  }

  toggleSelectAll(selectAllValue: boolean) {
    this.filteredPlants
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe((val) => {
        if (selectAllValue) {
          this.plantMultiCtrl.patchValue(val);
        } else {
          this.plantMultiCtrl.patchValue([]);
        }
      });
  }
  protected setToggleAllCheckboxState() {
    let filteredLength = 0;
    if (this.plantMultiCtrl && this.plantMultiCtrl.value) {
      this.filteredPlantCache.forEach((el) => {
        if (this.plantMultiCtrl.value.indexOf(el) > -1) {
          filteredLength++;
        }
      });
      this.isIndeterminate =
        filteredLength > 0 && filteredLength < this.filteredPlantCache.length;
      this.isChecked =
        filteredLength > 0 && filteredLength === this.filteredPlantCache.length;
    }
  }

  private fetchAllDiscountPrice(): void {
    this.priceListService.findToComboBoxDiscountList().subscribe({
      next: (res) => {
        this.discountList = res.data;
      },
      error: (err) => {
        this.handlerMessage.error({
          message: err.error.message,
          alternativeMessage: "Error al obtener listas de descuento."
        });
      },
    });
  }


  private fetchCompanies(): void {
    this.companyService.findToComboBox().subscribe((res) => {
      this.companyList = res.data;
      this.companiesLoaded = true;
      this.filteredCompany.next(this.companyList);

      // listen for search field value changes
      this.companyMultiFilterCtrl.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
          this.filterCompanyMulti();
          this.setToggleAllCheckboxStateCompany();
        });
    });
  }

  protected filterCompanyMulti() {
    if (!this.companyList) {
      return;
    }
    // get the search keyword
    let search = this.companyMultiFilterCtrl.value;
    if (!search) {
      this.filteredCompanyCache = this.companyList;
      this.filteredCompany.next(this.companyList);
      return;
    } else {
      search = search.toLowerCase();
    }
    // Filtrar los precios por nombre o código
    this.filteredCompanyCache = this.companyList.filter((material) => {
      const nameMatches = material.name.toLowerCase().indexOf(search) > -1;
      const codeMatches =
        material?.externalKeys?.code.toLowerCase().indexOf(search) > -1;
      return nameMatches || codeMatches;
    });
    this.filteredCompany.next(this.filteredCompanyCache);
  }

  toggleSelectAllComp(selectAllValue: boolean) {
    this.filteredCompany
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe((val) => {
        if (selectAllValue) {
          this.companyMultiCtrl.patchValue(val);
        } else {
          this.companyMultiCtrl.patchValue([]);
        }
      });
  }
  protected setToggleAllCheckboxStateCompany() {
    let filteredLength = 0;
    if (this.companyMultiCtrl && this.companyMultiCtrl.value) {
      this.filteredCompanyCache.forEach((el) => {
        if (this.companyMultiCtrl.value.indexOf(el) > -1) {
          filteredLength++;
        }
      });
      this.isIndeterminateComp =
        filteredLength > 0 && filteredLength < this.filteredCompanyCache.length;
      this.isCheckedComp =
        filteredLength > 0 && filteredLength === this.filteredCompanyCache.length;
    }
  }


  private fetchPriceList(): void {
    this.priceListService.findToComboBoxPriceList().subscribe((res) => {
      this.priceList = res.data;
    });
  }


  openCreateModal(): void {
    this.currentUpdateWarehouse=null;
    this.ensureModalDataLoaded();
    this.currentCreateWarehouse = this.initializeCreateWarehouse();
    this.dialogRefAdd = this.dialog.open(this.addModal, {
      disableClose:true,
      width: '95%',
      maxWidth: '800px',
      maxHeight: '90vh'
    })
    // this.dialogRefAdd.afterClosed().subscribe((result) => result && this.createWarehouse());
    this.dialogRefAdd.afterClosed().subscribe((result) => { result });

  }

  openEditModal(warehouse: WarehouseAttributes): void {
    this.ensureModalDataLoaded();
    this.currentUpdateWarehouse = { ...warehouse,
      externalKeys: {
        code: warehouse?.externalKeys?.code ?? null,
        }
     };
    this.dialogRefEdit = this.dialog.open(this.editModal, {
      disableClose:true,
      width: '95%',
      maxWidth: '800px',
      maxHeight: '90vh'
    })
    // this.dialogRefEdit.afterClosed().subscribe((result) => result && this.updateWarehouse(warehouse._id.toString()));
    this.dialogRefEdit.afterClosed().subscribe((result) => { result });
  }

  createWarehouse(): void {

        const WarehouseData = {
      ...this.currentCreateWarehouse,
      plantsId: this.plantMultiCtrl.value.map(
        (route: PlantsAttributes) => route._id.toString()
      ),
      priceListId: this.currentCreateWarehouse.priceListId ? this.currentCreateWarehouse.priceListId : null,
      discountListId: this.currentCreateWarehouse.discountListId ? this.currentCreateWarehouse.discountListId : null,
    };

    const dataToSend: any = Object.entries(WarehouseData).reduce(
      (acc, [key, value]) => {
        if (value !== "" && !(Array.isArray(value) && value.length === 0)) {
          // Ignora cadenas vacías y arreglos vacíos
          acc[key] = value;
        }
        return acc;
      },
      {}
    );
    this.warehouseService.create(dataToSend).subscribe({
      next: () => {
        this.handlerMessage.success({
          message: "Registro creado con éxito"
        });
        this.findAllWithCount();
        this.dialogRefAdd.close(true);
      },
      error: (err) => {
        this.handlerMessage.error({
          message: err.error.message,
          alternativeMessage: "Error al crear el registro"
        });
      },
    });
  }

  updateWarehouse(id: string): void {
    if (this.currentUpdateWarehouse) {
      const updatedWarehouse: IUpdateWarehouse = {
        ...this.currentUpdateWarehouse,
        companyid: this.currentUpdateWarehouse.company._id.toString(),
        priceListId: this.currentUpdateWarehouse.priceList ? this.currentUpdateWarehouse.priceList._id.toString() : undefined,
        discountListId: this.currentUpdateWarehouse.discountList ? this.currentUpdateWarehouse.discountList._id.toString() : undefined,
        plantsId: this.plantMultiCtrl.value.map((material: PlantsAttributes) =>
          material._id.toString()
        ),
      };
      this.warehouseService.update(id, updatedWarehouse).subscribe({
        next: () => {
          this.handlerMessage.success({
            message: "Registro actualizado con éxito",
          });

          this.findAllWithCount();
          this.dialogRefEdit.close(true);
        },
        error: (err) => {
          this.handlerMessage.error({
            message: err.error.message,
            alternativeMessage: "Error al actualizar el registro"
          });
        },
      });
    }
  }

  onStatusChange(event: boolean, warehouse: WarehouseAttributes): void {
    const originalStatusId = warehouse.statusId;
    const updatedStatusId = event ? 1 : 0;
    const updatedWarehouse = { ...warehouse, statusId: updatedStatusId };

    this.warehouseService
      .update(warehouse._id.toString(), updatedWarehouse)
      .subscribe({
        next: () => {
          this.findAllWithCount();
        },
        error: () => {
          warehouse.statusId = originalStatusId; // Volver al estado original si falla
          this.handlerMessage.error({
            message: "Error al actualizar el estado."
          });
          this.findAllWithCount();
        },
      });
  }

  onreadStatusChange(event: boolean, warehouse: WarehouseAttributes): void {
    const originalStatusId = warehouse.readOnly;
    const updatedStatusId = event ? true : false;
    const updatedWarehouse: any = { readOnly: updatedStatusId };

    this.warehouseService
      .update(warehouse._id.toString(), updatedWarehouse)
      .subscribe({
        next: () => {
          this.findAllWithCount();
        },
        error: () => {
          warehouse.readOnly = originalStatusId; // Volver al estado original si falla
          this.handlerMessage.error({
            message: "Error al actualizar el estado."
          });
          this.findAllWithCount();
        },
      });
  }

  openDeleteDialog(warehouse: WarehouseAttributes): void {
    // Usar el nuevo ConfirmationService para eliminar
    this.confirmationService
      .confirmDelete(
        `el almacén "<strong>${warehouse.name}</strong>" (Código: ${warehouse.externalKeys?.code || 'N/A'})`,
        'Esta acción eliminará permanentemente el almacén y sus relaciones asociadas.'
      )
      .subscribe((confirmed) => {
        if (confirmed) {
          this.delete(warehouse._id.toString());
        }
      });
  }

  delete(id: string): void {
    this.warehouseService.remove(id).subscribe(() => {
      this.findAllWithCount();
      this.handlerMessage.success({
        message: "Registro eliminado con éxito"
      });
    });
  }

  compareById(item1: any, item2: any): boolean {
    return item1 && item2 ? item1._id === item2._id : item1 === item2;
  }
  onPlantsSelectionChange(plantsId: string[]): void {
    if (this.currentUpdateWarehouse) {
      this.currentUpdateWarehouse.plants = plantsId.map(
        (plantId) =>
          this.plantList.find((sub) => sub._id.toString() === plantId)!
      );
    }
  }

  
  onPriceSelectionChange(priceListId: string): void {
    if (this.currentUpdateWarehouse) {
      this.currentUpdateWarehouse.priceList = this.priceList.find(
        (price) => price._id.toString() === priceListId
      )!;
    }
  }

  onDiscountPriceSelectionChange(priceListId: string): void {
    if (this.currentUpdateWarehouse) {
      this.currentUpdateWarehouse.discountList = this.discountList.find(
        (price) => price._id.toString() === priceListId
      )!;
    }
  }

  onCompanySelectionChange(companyid: string): void {
    if (this.currentUpdateWarehouse) {
      this.currentUpdateWarehouse.company = this.companyList.find(
        (price) => price._id.toString() === companyid
      )!;
    }
  }

  clearFilters(): void {
    this.selectedStatus = [];
    this.plantMultiCtrl.setValue([]);
    this.companyMultiCtrl.setValue([]);
    this.searchQuery = "";
    this.form.reset({
      companyId: null,
      plantId: null,
    });
    this.findAllWithCount();
  }

  //exportar
  onExportButtonPressed() {
    if (!this.warehouseExport.canStartTask()) return;
    const dialogRef = this.dialog.open(ExportDialogComponent, {
      data: { title: WAREHOUSE_TITLE },
    });
    dialogRef.afterClosed().subscribe((options: ExportOptions) => {
      if (options) {
        this.warehouseExport.export(
          options.format,
          options.range,
          this.totalItems,
          this.pageSize,
          this.pageIndex,
        );
      }
    });
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }
}
